









































































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';
import { translate } from '@/i18n';
import { ActaService } from '../services/ActaService';
import { lazyInject } from '../ioc/DIContainer';
import { TYPES } from '../ioc/Types';

@Component({
  methods: {
    translate
  }
})
export default class JournalDetailsComponent extends Vue {
  @Prop() private modalData!: any;

  @lazyInject(TYPES.ActaService)
  private actaService!: ActaService;

  private DocumentRequest: any = {};
  private requestForm: { form: any } = { form: null };
  private isLoading: boolean = false;
  private showRequestForm: boolean = false;
  created () {
    this.requestForm.form = this.$form.createForm(this, {
    });
  }
  mounted () {
    this.showRequestForm = this.modalData.document.Title !== null && this.modalData.document.Title !== '' && this.modalData.document.ScreeningCode === null;
  }
  handleCancel () {
    this.modalData.visible = false;
  }
  formatDate (date: Date) {
    return moment(date).format('L');
  }
  handleSubmit (e: any) {
    e.preventDefault();
    var isValid = false;
    this.requestForm.form.validateFields((err: any) => {
      if (!err) {
        isValid = true;
      }
    });
    if (!isValid) {
      return;
    }
    this.isLoading = true;
    var req = {
      TenantSsoId: this.modalData.tenantId,
      DocumentId: this.modalData.document.DocumasterId,
      Email: this.requestForm.form.getFieldValue('Email'),
      Name: this.requestForm.form.getFieldValue('Name'),
      Phone: this.requestForm.form.getFieldValue('Phone'),
      Organization: this.requestForm.form.getFieldValue('Organization'),
      EmailBody: `${translate('post_journal_details.email_body')}`,
      EmailSubject: `${translate('post_journal_details.email_subject')}` + ' - ' + this.modalData.document.Identificator
    };
    this.actaService.sendPostJournalDocument(this.modalData.tenantId, req, this.dataFetched, this.fetchError);
    this.modalData.visible = false;
    this.$notification['info']({
      message: 'Info',
      description: 'You will receive the requested document via email',
      duration: 5
    });
  }
  dataFetched () {
    this.isLoading = false;
    this.modalData.visible = false;
  }
  fetchError () {
    this.isLoading = false;
  }
}

